import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Content.st.css';

class Content extends React.Component {
  static displayName = 'Card.Content';

  static propTypes = {
    /** Applies a data-hook HTML attribute to be used in the tests */
    dataHook: PropTypes.string,
    /** Accepts any component as a child element to display inside the card content area */
    children: PropTypes.node,
    /** Controls paddings of the content area */
    size: PropTypes.oneOf(['medium', 'large']),
  };

  static defaultProps = {
    size: 'medium',
  };

  _getChildName = children =>
    children &&
    children.type &&
    (children.type.displayName || children.type.name);

  render() {
    const { children, size, dataHook } = this.props;
    const isEmptyStateContent = this._getChildName(children) === 'EmptyState';

    return (
      <div
        data-hook={dataHook}
        data-size={size}
        className={st(classes.root, {
          size,
          emptyStateContent: isEmptyStateContent,
        })}
      >
        {children}
      </div>
    );
  }
}

export default Content;
